import React, { useEffect, useRef, useState } from 'react';

import ConferenceBody from './web/ConferenceBody';
import ConferenceFooter from './web/ConferenceFooter';
import ConferenceHeader from './web/ConferenceHeader';
import ConferenceRightMenu from './web/ConferenceRightMeun';

import { debounce } from 'lodash';
import { getCurrentConference, getGroupId } from '../../base/conference';
import { getScreenType, getUserAgentType } from '../../base/util';
import { setMiddleAttendancesCookies } from '../../options';
import { DualMonitor, layoutType, setLayoutStyleProperty } from '../../video-layout-mode';

import '../../../assets/css/conference.scss';
import { connect } from '../../base/redux';
import GroupDualMonitor from '../../video-layout-mode/components/dualMonitor/GroupDualMonitor';
import { setCanvasProperty } from '../../base/canvas';
import { PAGE_TYPE, setAppPage } from '../../base/app';

let hideHeadAndFoot, prevJoin;

function _mapStateToProps(state) {
    const groupId = getGroupId(state);
    const lastUpdateTimestamp = state["features/group"].lastUpdateTimestamp;
    const joinRoom = getCurrentConference(state);
    
    return {
        groupId, lastUpdateTimestamp, joinRoom
    }
}

export default connect(_mapStateToProps)(Conference);

function Conference ({
    dispatch, 
    roomName, roomUuid, roomCode, lastUpdateTimestamp, joinRoom
}) {
    const parentElement = useRef();
    const contentElment = useRef();
    const [ userAgentType, setUserAgentType ] = useState(layoutType.desktop);
    const [ screenType, setScreenType ] = useState(layoutType.desktop);
    const [ hideSection, setHideSection ] = useState(false);
    const [ resize, setResize ] = useState();

    useEffect(() => {
        if (joinRoom === false) {
            dispatch(setAppPage(PAGE_TYPE.DEVICE));
            // APP.mateManagement.connection();
            return;
        }
        APP.UI.showLoading(true);   
        
        // 화면 크기 set
        updateLayoutType();
        // 화면 세팅 가져오기 
        setUserType();
        // 중간 출석 가져오기
        setMiddleAttendancesCookies();

        if (APP.function.record.startCanvasRec) {
            setTimeout(() => {
                dispatch(setCanvasProperty({ record: true }));
            }, 1000);
        }

        /**
         * (Event)
         */
        // 장치 변경 이벤트 
        APP.mateManagement.addDeviceListChange();

        // tab을 닫는 경우
        window.addEventListener('beforeunload', unload);
        // window 의 사이즈가 변경된 경우
        window.addEventListener('resize', setUserType);

        return (() => {
            unload();

            APP.UI.showLoading(false);
        });
    }, []);

    useEffect(() => {
        if (joinRoom === true) {
            // 화면 세팅 가져오기 
            setUserType();

            setHideSection(false);
            APP.UI.showLoading(false);
        } 
        prevJoin = joinRoom;
    }, [joinRoom]);

    useEffect(() => {
        updateLayoutType();
    }, [lastUpdateTimestamp]);

    useEffect(() => {
        if (layoutType.mobile === userAgentType || layoutType.tablet === userAgentType) {
            updateLayoutType();

            if (parentElement && parentElement.current) {
                if (hideSection) {
                    if (document.getElementById("option_button")) {
                        setHideSection(false);
                        return;
                    }

                    parentElement.current.classList.add('section_hide');
                } else {
                    parentElement.current.classList.remove('section_hide');
                }
            }
            
            // timer
            if (hideHeadAndFoot) clearTimeout(hideHeadAndFoot);
            hideHeadAndFoot = setTimeout(() => { if (hideSection === false) setHideSection(true); }, 1000 * 3);
        } else {
            if (parentElement && parentElement.current) parentElement.current.classList.remove('section_hide');
            setHideSection(false);
        }
    }, [hideSection]);

    useEffect(() => {
        if (layoutType.mobile === userAgentType || layoutType.tablet === userAgentType) {
            if (contentElment.current) {
                contentElment.current.addEventListener('click', handlerHideSection, false);
            }
        } else {
            setHideSection(false);
        }

        return (() => {
            if (contentElment.current) {
                contentElment.current.removeEventListener('click', handlerHideSection, false);
            }
        });
    }, [userAgentType]);

    const unload = e => {
        window.close();

        APP.UI.closeModal();
        APP.mateManagement.unload();
        APP.mateManagement.removeDeviceListChange();

        window.removeEventListener('beforeunload', unload);
        window.removeEventListener('resize', setUserType);
    };
    
    const handlerHideSection = (e) => {
        try {
            const classList = e.target.classList;
            if (classList && (classList.contains('boardImg') || classList.contains('noClick') || classList.contains('icoImg'))) return;
    
            if ((e.target && e.target.classList.contains('noClick')) || (e.target.parentNode && e.target.parentNode.closest('div.noClick'))) return;
    
            const tagName = e.target.tagName.toUpperCase();            
            if ( tagName === 'SVG' || tagName === 'PATH' || (window.getEventListeners && window.getEventListeners(e.target)?.click)) return;

            setHideSection(hideSection => { return !hideSection; });
        } catch (err) {
            console.log(err);
            return false;
        }        
    };

    const setUserType = () => {
        setHideSection(true);

        setUserAgentType(getUserAgentType());
        setScreenType(getScreenType());
        updateLayoutType();
    };

    const updateLayoutType = () => {        
        if (parentElement && parentElement.current) {
            let { width: layoutWidth, height: layoutHeight } = parentElement.current.getBoundingClientRect();

            if (hideSection === false) layoutHeight = layoutHeight - 125;

            dispatch(setLayoutStyleProperty(layoutWidth, layoutHeight));
            setResize(Date.now());
        }
    };

    return (
        <div ref={parentElement} className="child conference">
            <ConferenceHeader roomName={roomName} roomUuid={roomUuid} screenType={screenType} userAgentType={userAgentType} /> 
            
            <div className="content" ref={contentElment}>
                { joinRoom && <>
                    <ConferenceBody roomCode={roomCode} resize={resize} userAgentType={userAgentType} /> 
                    <ConferenceRightMenu screenType={screenType} />
                </> }
            </div>

            <ConferenceFooter screenType={screenType} userAgentType={userAgentType} /> 

            <DualMonitor />
            <GroupDualMonitor />
            <div style={{ display: "none" }}>
                <div id="canvas_sd" style={{ position: "absolute", top: 0, left: 0 }}></div>
            </div>
        </div> 
    );
}